import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Form, withFormik } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as yup from 'yup';

import CheckboxIcon from 'common/shared-ui/src/icons/CheckboxIcon';
import CheckboxIconChecked from 'common/shared-ui/src/icons/CheckboxIconChecked';

import { checkLicense } from '../../../../packages/common/api';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

// Original class: LoginFormRoot
const StyledLoginFormRoot = styled(Box)(theme => ({
  maxWidth: 300,
  width: '100%',
}));
// Original class: hidden
const StyledHidden = styled(FormControlLabel)(theme => ({
  visibility: 'hidden',
}));
const LoginForm = ({
  handleChange,
  values,
  errors,
  handleSubmit,
  isSaveData,
  handleChangeDataSave,
}) => {
  const getLocalString = useTranslation();
  const [licenseStatus, setLicenseStatus] = useState();
  const [licenseStatusDate, setLicenseStatusDate] = useState();
  const checkLicenseStatus = useCallback(async () => {
    try {
      const { data } = await checkLicense();
      if (data.status == 'soon') {
        setLicenseStatus(
          getLocalString('AuthContainer', 'errors', 'licenseSoon'),
        );
        setLicenseStatusDate(data.expirationDate);
      } else if (data.status == 'expired') {
        setLicenseStatus(
          getLocalString('AuthContainer', 'errors', 'licenseExpired'),
        );
      }
    } catch (error) {
      console.error('CANNOT GET LICENSE', error);
    }
  }, [getLocalString]);

  useEffect(() => {
    checkLicenseStatus();
  }, [checkLicenseStatus]);
  return (
    <StyledLoginFormRoot>
      <Form align='left' onSubmit={handleSubmit}>
        <Box
          sx={{
            marginBottom: errors.requestAnswer ? 2.5 : 10,
          }}
        >
          <Typography variant='h1' align='center'>
            {getLocalString('AuthContainer', 'title')}
          </Typography>
        </Box>
        <Typography
          variant='h5'
          color='error'
          align='center'
          sx={{
            marginBottom: 2.5,
          }}
        >
          {licenseStatus}
          {licenseStatusDate}
        </Typography>
        <Typography
          variant='h5'
          color='error'
          align='center'
          sx={{
            marginBottom: 2.5,
          }}
        >
          {errors.requestAnswer}
        </Typography>
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <TextField
            variant='outlined'
            type='text'
            name='username'
            value={values.username}
            onChange={handleChange}
            error={!!errors?.username}
            helperText={getLocalString('AuthContainer', 'loginInput')}
            placeholder={getLocalString('AuthContainer', 'loginInputLbl')}
            required
            fullWidth
          />
        </Box>
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <TextField
            variant='outlined'
            type='password'
            name='password'
            value={values.password}
            onChange={handleChange}
            error={!!errors?.password}
            helperText={getLocalString('AuthContainer', 'passwordInput')}
            placeholder={getLocalString('AuthContainer', 'passwordInpuLbl')}
            required
            fullWidth
          />
        </Box>
        <Grid
          container
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <StyledHidden
            control={
              <Checkbox
                icon={
                  <CheckboxIcon width='12' height='12' viewBox='0 0 12 12' />
                }
                checkedIcon={
                  <CheckboxIconChecked
                    width='12'
                    height='12'
                    viewBox='0 0 12 12'
                  />
                }
              />
            }
            label={getLocalString('AuthContainer', 'remember')}
            value={isSaveData}
            onChange={handleChangeDataSave}
          />
          {/*
          <Link to="/recovery">
            <Typography variant="h5">{getLocalString('AuthContainer', 'forgotPswrd')}</Typography>
          </Link>
          */}
        </Grid>
        <Grid
          container
          wrap='nowrap'
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 5,
          }}
        >
          <Button
            disableRipple
            variant='defaultBlue'
            color='primary'
            type='submit'
          >
            {getLocalString('AuthContainer', 'loginBtn')}
          </Button>
        </Grid>
      </Form>
    </StyledLoginFormRoot>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    username: '',
    password: '',
  }),
  validationSchema: yup.object().shape({
    username: yup.string().min(1, 'Too Short!').required('Required'),
    password: yup.string().min(2, 'Too Short!').required('Required'),
  }),
  handleSubmit(formValues, { props, resetForm, setSubmitting, setErrors }) {
    props.handleSignIn({
      ...formValues,
      resetForm,
      setSubmitting,
      setErrors,
    });
  },
})(LoginForm);
